// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"9e7d0f9fa4fbbcfc19c8","293":"b209dc427ec519a2c4b2","452":"de15bec7ebc4fe924405","896":"2dd98b1aa7d6671ede1f"}[chunkId] + ".js";
};